export default __webpack_public_path__ + "static/media/11.716f2142.png";